<template>
  <!--  todo:早课数量为0-->
  <div class="colorful-background wrapper-grid special">
    <div :class="['title', { animate__animated: isFirst }, 'animate__flipInX']">
      <span class="big-font is-block">清晨</span>
      <span class="big-font is-block">08:05</span>
    </div>

    <div :class="['img', { animate__animated: isFirst }, 'animate__fadeIn']">
      <image-box img-u-r-l="/pic/7.png"></image-box>
    </div>

    <div
      :class="[
        'text',
        { animate__animated: isFirst },
        'animate__fadeIn',
        'text-align-left',
      ]"
      style="align-items: flex-end;"
    >
      <span class="middle-font">
        有{{ schedule_morning_class.ThisTerm }}次
      </span>
      <span class="small-font">
        您在此时踏入了教室
      </span>
      <span class="small-font">
        伴着晨曦与朝露
      </span>
      <span class="small-font">
        端坐于早课学堂
      </span>
    </div>

    <div
      :class="[
        'slogan',
        { animate__animated: isFirst },
        'animate__fadeIn',
        'big-margin-top',
      ]"
    >
      <span class="small-font">见过八点的杭电吗?</span>
      <span class="small-font small-margin-top"
        >与小助手一起见证朝阳初升的清晨吧</span
      >
      <!--      <span class="slogan-font slogan-position"></span>-->
    </div>

    <div class="footer middle-margin-bottom">
      <div class="very-small-font">
        课程数据由杭电教务处提供,分析数据均在理想状态下计算
      </div>
      <span class="very-small-font">数据仅供参考</span>
    </div>
  </div>
</template>

<script>
import store from '@/store/store'
import ImageBox from '@/components/utils/imageBox'

export default {
  name: 'morningClassPage',
  components: { ImageBox },
  props: {
    isFirst: { type: Boolean, default: true },
  },
  computed: {
    schedule_morning_class: function () {
      return store.state.$data.data.Schedule.MorningClass
    },
  },
}
</script>

<style scoped>
.img.animate__animated {
  animation-delay: var(--first-delay);
  animation-duration: var(--defalut-continue);
}

.title.animate__animated {
  animation-delay: var(--first-delay);
}

.text.animate__animated {
  animation-delay: var(--second-delay);
  animation-duration: var(--defalut-continue);
}

.slogan.animate__animated {
  animation-delay: var(--third-delay);
  animation-duration: var(--defalut-continue);
}
.wrapper-grid.special {
  --second-color: var(--light-orange);
  --page-background-color: var(--hduhelp-blue);
  --first-color: var(--eggplant-purple);
  grid-template-rows: 5vh repeat(4, minmax(auto, auto)) 1fr 5vh;
  grid-template-areas:
    '. .      .'
    '. title  .'
    '. img    .'
    '. text   .'
    '. slogan .'
    '. .      .'
    '. footer .';
}
</style>
